import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'
import type { ComponentProps } from 'react'

export type CollapsibleProps = ComponentProps<typeof CollapsiblePrimitive.Root>

function Collapsible({ ...props }: CollapsibleProps) {
  return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />
}

export type CollapsibleTriggerProps = ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger>

function CollapsibleTrigger({ ...props }: CollapsibleTriggerProps) {
  return <CollapsiblePrimitive.CollapsibleTrigger data-slot="collapsible-trigger" {...props} />
}

export type CollapsibleContentProps = ComponentProps<typeof CollapsiblePrimitive.CollapsibleContent>

function CollapsibleContent({ ...props }: CollapsibleContentProps) {
  return <CollapsiblePrimitive.CollapsibleContent data-slot="collapsible-content" {...props} />
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
